import { render, staticRenderFns } from "./CambiarGenero.vue?vue&type=template&id=13e2ca83&scoped=true&"
import script from "./CambiarGenero.vue?vue&type=script&lang=js&"
export * from "./CambiarGenero.vue?vue&type=script&lang=js&"
import style0 from "./CambiarGenero.vue?vue&type=style&index=0&id=13e2ca83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2ca83",
  null
  
)

export default component.exports